/* eslint-disable */
import React, { Suspense, useEffect, useRef } from 'react';

import {
  rbrBannerDetailModel,
  rbrBenefitsModel,
  rbrClinicsModel,
  rbrCoverageModel,
  rbrHeroModel,
  rbrPlansFlexibleModel,
  rbrQuestionModel,
  CYBER_CONTENT_BANNER,
} from '../../../../models/step-initial';
import RbrHeroSection from '../../../../modules/step-initial/rbr-hero';
import RbrFlexiblePlans from '../../../../modules/step-initial/rbr-flexible-plans';
import ScrollDownAnimated from '../../../../modules/step-initial/scroll-down-animated';
import { Layout } from '../../../../components/organisms';
import { BannerCampaign } from '../../../../components/organisms/BannerCampaign';
import useNearScreen from '../../../../hooks/useNearScreen';
import { BannerCampaignDays } from '../../../../modules/step-initial/BannerCampaignDays';
import Experiment from '../../../../modules/step-initial/experiment';
import Loadable from '../../../../components/atoms/Loadable';
import { useAppContext } from '../../../../AppProvider';

const RbrClinics = Loadable(React.lazy(() => import('../../../../modules/step-initial/rbr-clinics')));
const RbrCoverage = Loadable(React.lazy(() => import('../../../../modules/step-initial/rbr-coverage')));
const RbrBenefits = Loadable(React.lazy(() => import('../../../../modules/step-initial/rbr-benefits')));
const RbrBannerDetail = Loadable(React.lazy(() => import('../../../../modules/step-initial/rbr-banner-detail')));
const RbrQuestions = Loadable(React.lazy(() => import('../../../../modules/step-initial/rbr-questions')));

const SectionLazy = () => {
  const { isNearScreen, elementRef } = useNearScreen('30px');
  const sectionRef = useRef(false);

  if (isNearScreen) {
    sectionRef.current = isNearScreen;
  }

  return (
    <div ref={(ref) => (elementRef.current = ref)} id="section-lazy-coverage" style={{ minHeight: '500px' }}>
      <Suspense
        fallback={
          <div className="rbr__pre-img" style={{ textAlign: 'center' }}>
            <div />
          </div>
        }
      >
        {sectionRef.current ? (
          <>
            <RbrClinics authoring={rbrClinicsModel} />
            <RbrCoverage authoring={rbrCoverageModel} />
            <RbrBenefits authoring={rbrBenefitsModel} />
            <RbrBannerDetail authoring={rbrBannerDetailModel} />
            <RbrQuestions authoring={rbrQuestionModel} />
          </>
        ) : (
          <div />
        )}
      </Suspense>
    </div>
  );
};

const StepInitial = () => {
  const { dispatch } = useAppContext();
  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 2);

    sessionStorage.removeItem('__hidePhone');
    // getTagVirtual('sol:comprar:seguro-salud-flexible');
    localStorage.removeItem('checkoutError');
    localStorage.removeItem('checkoutSuccess');
    localStorage.removeItem('retriesRender');
  }, []);
  const {
    state: { experiments },
  } = useAppContext();
  const { experimentCyber } = experiments;
  const { isActive: isCyberActive, startDate: cyberStartDate, endDate: cyberEndDate } = experimentCyber;

  const handleExperimentCyber = () => {
    const { isActive, startDate, endDate } = window.CyberExperiment || {};
    if (isActive) {
      dispatch({
        type: 'SET_EXPERIMENT_CYBER',
        payload: {
          isActive: !!isActive,
          startDate: startDate || null,
          endDate: endDate || null,
        },
      });
    }
  };
  useEffect(() => {
    window.showCyberExperiment = handleExperimentCyber;
    return () => {
      delete window.showCyberExperiment;
    };
  }, []);

  return (
    <>
      <Layout>
        {isCyberActive && (
          <BannerCampaign
            dynamicContent={CYBER_CONTENT_BANNER.map((item) => ({
              ...item,
              venta_digital_cintillo: {
                ...item.venta_digital_cintillo,
                time: {
                  ...item.venta_digital_cintillo.time,
                  start_date: cyberStartDate,
                  final_date: cyberEndDate,
                },
              },
            }))}
            valueEntry={CYBER_CONTENT_BANNER[0].venta_digital_cintillo.name_product}
          />
        )}
        <Experiment />
        <BannerCampaignDays />
        <RbrHeroSection authoring={rbrHeroModel} />
        <ScrollDownAnimated />
        <RbrFlexiblePlans authoring={rbrPlansFlexibleModel} />
        <SectionLazy />
      </Layout>
    </>
  );
};

export default StepInitial;
